// Agent bridge. Agents read the SAME widget models the orb renders and can ask
// for a widget to surface ("invoked"); actions on a model call the real tool
// writes, so there is no separate agent data. No chat is faked here — the deity
// chat itself is DeitySheet (useSyqiChat), opened through NowOrb's onAgent.
import { useEffect, useState } from 'react';
import type { OrbWidgetModel } from './types';

let snapshot: Record<string, OrbWidgetModel> = {};
let invoked = new Set<string>();
const subs = new Set<() => void>();
const emit = () => subs.forEach((f) => f());

/** Latest widget models by id (what an agent "reads"). */
export const getOrbWidgetSnapshot = (): Readonly<Record<string, OrbWidgetModel>> => snapshot;
/** Called by the orb after each render. */
export function publishOrbWidgets(models: Record<string, OrbWidgetModel>) {
  snapshot = models;
}
/** An agent surfaces a widget in its ORDER section (until dismissed). */
export function invokeOrbWidget(id: string) {
  if (invoked.has(id)) return;
  invoked = new Set(invoked).add(id);
  emit();
}
export function dismissOrbWidget(id: string) {
  if (!invoked.has(id)) return;
  invoked = new Set(invoked);
  invoked.delete(id);
  emit();
}
export function useInvoked(): ReadonlySet<string> {
  const [v, setV] = useState(invoked);
  useEffect(() => {
    const f = () => setV(invoked);
    subs.add(f);
    return () => {
      subs.delete(f);
    };
  }, []);
  return v;
}
